/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GenerateInstallmentsDto = {
  /**
   * ID of the sales order
   */
  salesOrderId: number;
  /**
   * Total number of installments to generate
   */
  totalInstallments: number;
  /**
   * Date of the first installment
   */
  firstInstallmentDate: string;
  /**
   * Frequency of installments
   */
  frequency: GenerateInstallmentsDto.frequency;
  /**
   * Total amount to divide into installments
   */
  totalAmount: number;
  /**
   * Late fee amount per installment
   */
  lateFeePerInstallment?: number;
  /**
   * General notes for all installments
   */
  notes?: string;
};
export namespace GenerateInstallmentsDto {
  /**
   * Frequency of installments
   */
  export enum frequency {
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
    BIWEEKLY = 'BIWEEKLY',
  }
}
